import { renderDecimal } from '@synqo/frontend-component-library';
import classes from './JournalQuantity.module.css';

interface IProps {
    value: number;
    /** A cancelled booking is struck through in grey. */
    struckThrough: boolean;
}

/** The weight of a journal row in tons with 3 decimals. */
// @ai-generated 2026-10-26T15:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function JournalQuantity({ value, struckThrough }: IProps) {
    return (
        <span className={classes.quantity} data-cancelled={struckThrough || undefined}>
            {renderDecimal(value, 3)}
        </span>
    );
}
